import React from 'react'
import './style.css'

const SecurityFIrstSection = () => {

    const securityFirstContent = [
        {
            title: "Data Encryption with AES-256, TLS 1.3 & DigiCert Certification",
            description: "All data within the platform is encrypted at rest using AES-256 and in transit with TLS 1.3, secured through DigiCert-issued SSL certificates and FIPS 140-2 compliance. These technologies ensure end-to-end confidentiality, authenticity, and integrity for every data transaction.",
            singleIcon: "/images/chatbot-services-icons/data-encryption.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/aes-256.png", width: 50 },
                { icon: "/images/chatbot-security-icons/digicert.png", width: 120 },
                { icon: "/images/chatbot-security-icons/fips.png", width: 40 },
                { icon: "/images/chatbot-security-icons/tls-icons.png", width: 60 },
            ],
        },
        {
            title: "Data Segregation via AWS, PostgreSQL & RBAC Access Control",
            description:
                "Each client’s workspace operates in isolated AWS environments, leveraging PostgreSQL for secure data storage and RBAC (Role-Based Access Control) for fine-grained permissions. Security frameworks such as SOC 2, ISO 27001, and AWS Identity Manager safeguard against unauthorized access and cross-tenant visibility.",
            singleIcon: "/images/chatbot-services-icons/data-sets.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/aws.png", width: 70 },
                { icon: "/images/chatbot-security-icons/arbac.png", width: 70 },
                { icon: "/images/chatbot-security-icons/soc2.png", width: 45 },
                { icon: "/images/chatbot-security-icons/iso27001.png", width: 45 },
                { icon: "/images/chatbot-security-icons/postgre-sql.png", width: 50 },
            ],
        },
        {
            title: "Audit Logs Powered by Elastic Stack, Azure Monitor & Splunk",
            description:
                "Every interaction and system event is tracked through Elastic Stack (ELK) dashboards integrated with Microsoft Azure Monitor and Splunk analytics. This provides full visibility, traceability, and audit readiness for internal reviews, compliance checks, and real-time monitoring.",
            singleIcon: "/images/chatbot-services-icons/audit-logs.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/soc-type.png", width: 30 },
                { icon: "/images/chatbot-security-icons/amazon-cloud.png", width: 30 },
                { icon: "/images/chatbot-security-icons/iso27017.png", width: 30 },
                { icon: "/images/chatbot-security-icons/cloud-logging.png", width: 30 },
                { icon: "/images/chatbot-security-icons/azure.png", width: 70 },
                { icon: "/images/chatbot-security-icons/splunk.png", width: 60 },
                { icon: "/images/chatbot-security-icons/elastic-stack.png", width: 90 },
            ],
        },
        {
            title: "Sensitive Information Protection using OneTrust, Microsoft Purview & GDPR Compliance",
            description:
                "Personal and confidential data are automatically redacted and monitored through OneTrust and Microsoft Purview compliance frameworks. Our system adheres to GDPR, CCPA, and other global privacy laws ensuring no sensitive information is ever stored, shared, or exposed.",
            singleIcon: "/images/chatbot-services-icons/sensitive-information.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/amazon-comparehead.png", width: 70 },
                { icon: "/images/chatbot-security-icons/ccpa.png", width: 50 },
                { icon: "/images/chatbot-security-icons/gdpr.png", width: 50 },
                { icon: "/images/chatbot-security-icons/magnifine-glass.png", width: 50 },
                { icon: "/images/chatbot-security-icons/onetrust.png", width: 100 },
                { icon: "/images/chatbot-security-icons/purview.png", width: 130 },
            ],
        },
        {
            title: "Custom Data Retention on Amazon S3, Azure Blob Storage & NIST Standards",
            description:
                "You control how long your company’s chat and application data are stored, with flexible retention policies managed via Amazon S3 and Azure Blob Storage. All retention and deletion practices follow NIST 800-88 and ISO 27018 standards for secure data lifecycle management.",
            singleIcon: "/images/chatbot-services-icons/custom-data.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/amazon-s3.png", width: 100 },
                { icon: "/images/chatbot-security-icons/microsoft-azure.png", width: 160 },
                { icon: "/images/chatbot-security-icons/gppr-stars.png", width: 50 },
                { icon: "/images/chatbot-security-icons/nist.png", width: 70 },
            ],
        },
        {
            title: "Zero-Retention AI Policy with OpenAI & Anthropic Models",
            description:
                "Our AI chatbots operate under a Zero-Retention Policy, using OpenAI and Anthropic large language models that never reuse or train on your input data. Your conversations remain 100 % confidential and compliant with ISO 27001, SOC 2, and Responsible AI governance guidelines.",
            singleIcon: "/images/chatbot-services-icons/zero-retention.png",
            listOfIcons: [
                { icon: "/images/chatbot-security-icons/iso27.png", width: 45 },
                { icon: "/images/chatbot-security-icons/aicpasoc.png", width: 45 },
                { icon: "/images/chatbot-security-icons/open-ai.png", width: 100 },
                { icon: "/images/chatbot-security-icons/anthropic.png", width: 110 },
            ],
        },
    ];


    return (
        <>
            <section className="security-first-chatbot-section">
                <div className="container security-first-chatbot-section-container">
                    <div className="row justify-content-center text-center mb-5 security-first-chatbot-section-header">
                        <div className="col-lg-10">
                            <h2 className="security-first-chatbot-section-title mb-3">
                                <span className="security-first-chatbot-section-text-primary">Security First,</span> No Training on Your Data
                            </h2>
                            <p className="security-first-chatbot-section-subtitle">
                                Security is at the core of Botsonic. Our platform uses robust safeguards to protect your data &
                                preserve the confidentiality & integrity of your workspace.
                            </p>
                        </div>
                    </div>
                    <div className="row g-4 security-first-chatbot-section-features">
                        {securityFirstContent?.map((item, index) => {
                            return <div className="col-md-6 col-lg-4" key={index}>
                                <div className="security-first-chatbot-section-card p-4 h-100">
                                    <div className="security-first-chatbot-section-icon mb-3">
                                        <img src={item?.singleIcon} alt={item?.title} />
                                    </div>
                                    <h5 className="security-first-chatbot-section-card-title">{item?.title}</h5>
                                    <p className="security-first-chatbot-section-card-text">{item?.description}</p>
                                    <div className="secuiry-first-icons-box">
                                        {item?.listOfIcons?.map((icon, index) => {
                                            return <img key={index} src={icon?.icon} width={icon?.width} alt="Security Icon" />
                                        })}
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </section>

        </>
    )
}

export default SecurityFIrstSection